import React from "react";
import { lazyLoad, createIcon } from "./helpers";
import { userRoutes, departmentRoutes, designationRoutes, attendanceRoutes, 
  leavesRoutes, hrToolsRoutes, documentRoutes, payrollRoutes } from "./subRoutes";

const HRMSDashboard = lazyLoad("HRMS/Dashboard");
const EmployeeDashboard = lazyLoad("HRMS/Dashboard/EmployeeDashboard");
const Users = lazyLoad("Users");
const Departments = lazyLoad("HRMS/Departments");
const Designations = lazyLoad("HRMS/Designations");
const Attendance = lazyLoad("HRMS/Attendance");
const Leaves = lazyLoad("HRMS/Leaves");
const HRTools = lazyLoad("HRMS/HRTools");
const Documents = lazyLoad("HRMS/Documents");
const Payroll = lazyLoad("HRMS/Payroll");
const Calendar = lazyLoad("Calendar");

const TrainingCalendarList = lazyLoad("Calendar/TrainingCalendarList");
const TrainingCalendarMapView = lazyLoad("Calendar/TrainingCalendarMapView");
const LatestLocationMapView = lazyLoad("Calendar/LatestLocationMapView");


export const hradminMainRoutes = [
  {
    path: "HRMSDashboard",
    label: "Home",
    element: <HRMSDashboard />,
    icon: createIcon("home"),
    children: [{ path: "", element: <EmployeeDashboard /> }],
    module: ["hr"],
  },
  {
    path: "Users",
    element: <Users />,
    icon: createIcon("user"),    
    children: userRoutes,
    module: ["hr"],
  },
  {
    path: "Departments",
    element: <Departments />,
    icon: createIcon("department"),    
    children: departmentRoutes,
    module: ["hr"],
  },
  {
    path: "Designations",
    element: <Designations />,
    icon: createIcon("designation"),    
    children: designationRoutes,
    module: ["hr"],
  },
  {
    path: "Attendance",
    element: <Attendance />,
    icon: createIcon("designation"),
    children: attendanceRoutes,
    module: ["hr"],
  },
  {
    path: "Leaves",
    element: <Leaves />,
    icon: createIcon("designation"),    
    children: leavesRoutes,
    module: ["hr"],
  },
  {
    path: "HRTools",
    element: <HRTools />,
    icon: createIcon("administrator"),
    children: hrToolsRoutes,
    module: ["hr"],
  },
  {
    path: "Documents",
    element: <Documents />,
    icon: createIcon("repository"),
    children: documentRoutes,
    module: ["hr"],
  },
  {
    path: "Payroll",
    element: <Payroll />,
    icon: createIcon("administrator"),    
    children: payrollRoutes,
    module: ["hr"],
  },
  {
    path: "Calendar",
    element: <Calendar />,
    icon: createIcon("calender"),    
    children: [
      { path: "", element: <TrainingCalendarList /> },
      { path: "MapView", element: <TrainingCalendarMapView /> },
      { path: "LatestLocationMapView", element: <LatestLocationMapView /> },
    ],
    module: ["hr"],
  },
];

export const employeeMainRoutes = [
  {
    path: "HRMSDashboard",
    label: "Home",
    element: <HRMSDashboard />,
    icon: createIcon("home"),    
    children: [{ path: "", element: <EmployeeDashboard /> }],
    module: ["employee"],
  },
  {
    path: "Attendance",
    element: <Attendance />,
    icon: createIcon("designation"),    
    children: attendanceRoutes,
    module: ["employee"],
  },
  {
    path: "Leaves",
    element: <Leaves />,
    icon: createIcon("designation"),      
    children: leavesRoutes,
    module: ["employee"],
  },
  {
    path: "Documents",
    element: <Documents />,
    icon: createIcon("repository"),  
    children: documentRoutes,
    module: ["employee"],
  },
];